export const CREATE_PROJECT_MUTATION = `
    mutation CreateProject($workspace_id: Int!, $name: String!, $unique_id: String, $creator_count: Int!, $due_date: String!, $theme: JSON, $custom_properties: [CustomPropertyInput]) {
        createProject(workspace_id: $workspace_id, name: $name, unique_id: $unique_id, creator_count: $creator_count, due_date: $due_date, theme: $theme, custom_properties: $custom_properties) {
            id
            name
            unique_id
            due_date
            creator_count
            image
            theme
            account {
                id
                name
                image
                type
            }
            workspace {
                id
                name
                image
                thumb
                archived
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const CREATE_PROJECT_VIEWS_MUTATION = ` 
    mutation createView($project_id: Int!, $name: String!, $base: String!, $display_mode: String!, $blocked: JSON, $column_state: JSON, $grouping: JSON, $filter: JSON, $sort: JSON, $hidden_fields: JSON, $custom_properties: [CustomPropertyInput],$shared: Boolean, $locked: Boolean) {
        createView(project_id: $project_id, name: $name, base: $base, display_mode: $display_mode, blocked: $blocked, column_state: $column_state, grouping: $grouping, filter: $filter, sort: $sort, hidden_fields: $hidden_fields, custom_properties: $custom_properties, shared: $shared, locked: $locked ) {
            id
            name
            base
            display_mode
            column_state
            grouping
            filter
            hidden_fields
            sort
            blocked
            locked
            shared
            custom_properties {
                key
                value
            }
        }
    }
`;

export const UPDATE_PROJECT_VIEWS_MUTATION = `
    mutation updateView($id: Int!, $name: String, $display_mode: String, $blocked: JSON, $column_state: JSON, $grouping: JSON, $filter: JSON, $sort: JSON, $hidden_fields: JSON, $custom_properties: [CustomPropertyInput],$shared: Boolean, $locked: Boolean ) {
        updateView(id: $id, name: $name, display_mode: $display_mode, blocked: $blocked, column_state: $column_state, grouping: $grouping, filter: $filter, sort: $sort, hidden_fields: $hidden_fields, custom_properties: $custom_properties, shared: $shared, locked: $locked ) {
            id
            name
            base
            display_mode
            column_state
            grouping
            filter
            hidden_fields
            sort
            blocked
            locked
            shared
            custom_properties {
                key
                value
            }
        }
    }
`;

export const DELETE_PROJECT_VIEW_MUTATION = `
    mutation DeleteView($id: Int!) {
        deleteView(id: $id)
    }
    `;

export const DELETE_PROJECT_MUTATION = `
    mutation DeleteProject($id: Int!) {
        deleteProject(id: $id)
    }
`;

export const RESTORE_PROJECT_MUTATION = `
    mutation RestoreProject($id: Int!) {
        restoreProject(id: $id)
    }
`;

export const UPDATE_PROJECT_MUTATION = `
    mutation UpdateProject($id: Int!, $name: String, $unique_id: String, $creator_count: Int, $due_date: String, $image: String, $theme: JSON, $custom_properties: [CustomPropertyInput]) {
        updateProject(id: $id, name: $name, unique_id: $unique_id, creator_count: $creator_count, due_date: $due_date, image: $image, theme: $theme, custom_properties: $custom_properties) {
            id
            name
            unique_id
            due_date
            creator_count
            image
            theme
            workspace {
                id
                name
            }
            account {
                id
                name
                image
                type
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const ADD_USER_TO_PROJECT_MUTATION = `
    mutation AddUserToProject($workspace_id: Int!, $user_id: Int!, $role_id: Int) {
       addUserToProject(workspace_id: $workspace_id, user_id: $user)
    }
`;

export const REMOVE_USER_FROM_PROJECT_MUTATION = `
    mutation RemoveUserFromProject($workspace_id: Int!, $user_id: Int!, $role_id: Int) {
        removeUserFromProject(workspace_id: $workspace_id, user_id: $user_id, role_id: $role_id)
    }
`;

export const UPLOAD_PROJECT_CREATOR_SPREADSHEET_MUTATION = `
    mutation UploadCreatorSpreadsheet($project_id: Int!, $file: String!) {
        uploadCreatorSpreadsheet(project_id: $project_id, file: $file) {
            errors
            users {
                is_new
                id
                email
                username
                last_name
                first_name
                phone
                gender
                avatar
                address
                ethnicity
                favorite
                confirmed
                deliverable_count
                initial_quote
                products
                example_content
                notes
                tiktok_reach
                tiktok_impressions
                tiktok_engagement_rate
                instagram_reach
                instagram_impressions
                instagram_engagement_rate
                youtube_reach
                youtube_impressions
                youtube_engagement_rate
                errors
                social_channels {
                    is_new
                    id
                    handle
                    label
                    description
                    url
                    avatar
                    type
                    platform_uuid
                }
                deliverables {
                    id
                    platform_uuid
                    name
                    products
                }
                contract {
                    contract_status
                    contract_value
                    content_rights
                    content_rights_expiration_date
                    ecom_asset_rights
                    ecom_rights_expiration_date
                }
                custom_properties {
                    key
                    value
                }
                storefront {
                    url
                    audience_affinity
                }
            }
            products {
                is_new
                retailer {
                    id
                    name
                }
                product {
                    name
                    sku
                    url
                    image_url
                    description
                    keywords
                    price
                    currency
                }
            }
            entity_mapping {
                id
                field
                entity
                type
                options
                option_count
            }
        }
    }
`;

export const COMMIT_PROJECT_CREATOR_SPREADSHEET_MUTATION = `
    mutation CommitCreatorSpreadsheet($project_id: Int!, $users: JSON, $products: JSON, $entity_mapping: JSON) {
           commitCreatorSpreadsheet(project_id: $project_id, users: $users, products: $products, entity_mapping: $entity_mapping)
    }
`;

export const UPLOAD_PROJECT_BRIEF_FILES_MUTATION = `
    mutation uploadBrief($project_id: Int!, $upload_path: String!, $upload_name: String! ) {
        uploadBrief(project_id: $project_id, upload_path: $upload_path, upload_name: $upload_name) {
            id
            filename
            thumbnail
            tag
            type
            uploaded_by {
                id
                username
                avatar
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const DELETE_PROJECT_BRIEF_FILE_MUTATION = `
    mutation DeleteProjectBrief($project_id: Int!, $upload_id: Int!) {
        deleteProjectBrief(project_id: $project_id, upload_id: $upload_id)
    }
`;

export const GRANT_PROJECT_USER_ROLE_MUTATION = `
    mutation GrantUserRole($workspace_id: Int!, $project_id: Int!,$email: String, $user_id : Int, $role: RoleEnum, $notify_user: Boolean = true ) {
        grantUserRole(
            workspace_id: $workspace_id
            project_id: $project_id
            email: $email
            user_id: $user_id
            role: $role
            notify_user: $notify_user
        )
    }
`;

export const ATTACH_PROJECT_ENTITY_MAPPING = `
    mutation AttachEntityMapping ($project_id: Int!, $entity_mapping_id: Int! ) {
        attachEntityMapping(project_id: $project_id, entity_mapping_id: $entity_mapping_id) {
            id
            field
            entity
            type
            options
            created_at
        }
    }
`;

export const DETACH_PROJECT_ENTITY_MAPPING = `
    mutation DetachEntityMapping ($project_id: Int!, $entity_mapping_id: Int! ) {
        detachEntityMapping(project_id: $project_id, entity_mapping_id: $entity_mapping_id) 
    }
`;

export const COPY_PROJECT = `
    mutation CopyProject( $workspace_id : Int!, $project_id : Int!, $name : String! ) {
        copyProject( workspace_id: $workspace_id, project_id: $project_id, name: $name ) 
        {
            id
            name
            due_date
            creator_count
            image
            theme
            account {
                id
                name
                image
                type
            }
            workspace {
                id
                name
                image
                thumb
                archived
            }
            custom_properties {
                key
                value
            }
        }
    }
`;
